import React from "react"
import types from "prop-types"
import { ListSelect } from "shared/selects"
import {
  dayjsOrgTz, DAYS, MONTHS, WEEKS,
} from "utils/dateHelpers"
import { submissionsHeaderCopyByDateFilterType } from "utils/scheduledReportExportHelpers"
import DaysSubmissionDescription from "./DateFilterDescriptions/SubmissionDescription/DaysSubmissionDescription"
import WeeksSubmissionDescription from "./DateFilterDescriptions/SubmissionDescription/WeeksSubmissionDescription"
import MonthsSubmissionDescription from "./DateFilterDescriptions/SubmissionDescription/MonthsSubmissionDescription"

const SubmissionFilters = ({
  startDate, submissionPreviousRangeLength = null, submissionPreviousRangeUnit, setSubmissionPreviousRangeLength, lengthOptions, dateFilterType,
}) => (
  <>
    <div className="flex items-center my-4">
      <span className="required-prompt">{submissionsHeaderCopyByDateFilterType(dateFilterType)}</span>
      <ListSelect
        className="bordered-base-input ml-2 max-w-max"
        clearable={false}
        backspaceDelete={false}
        placeholder="1"
        name="submission_previous_range_length"
        required
        options={lengthOptions}
        value={submissionPreviousRangeLength}
        onChange={setSubmissionPreviousRangeLength}
        label={`select number of ${submissionPreviousRangeUnit}`}
      />
      <div className="ml-2">{submissionPreviousRangeUnit}</div>
    </div>

    {
      submissionPreviousRangeUnit === DAYS
      && (
        <DaysSubmissionDescription
          // DateInput sets value as a string
          startDate={dayjsOrgTz(startDate, "YYYY-MM-DD")}
          submissionPreviousRangeLength={submissionPreviousRangeLength}
          dateFilterType={dateFilterType}
        />
      )
    }
    {
      submissionPreviousRangeUnit === WEEKS
      && (
        <WeeksSubmissionDescription
          startDate={startDate}
          submissionPreviousRangeLength={submissionPreviousRangeLength}
          dateFilterType={dateFilterType}
        />
      )
    }
    {
      submissionPreviousRangeUnit === MONTHS
      && (
        <MonthsSubmissionDescription
          startDate={startDate}
          submissionPreviousRangeLength={submissionPreviousRangeLength}
          dateFilterType={dateFilterType}
        />
      )
    }
  </>
)

SubmissionFilters.propTypes = {
  dateFilterType: types.string.isRequired,
  startDate: types.object.isRequired,
  submissionPreviousRangeLength: types.number,
  submissionPreviousRangeUnit: types.string.isRequired,
  setSubmissionPreviousRangeLength: types.func.isRequired,
  lengthOptions: types.arrayOf(types.number).isRequired,
}

export default SubmissionFilters
